import { type Locale } from 'date-fns';
import { el } from 'date-fns/locale/el';
import { enUS } from 'date-fns/locale/en-US';
import { es } from 'date-fns/locale/es';
import { ptBR } from 'date-fns/locale/pt-BR';

export const dateFnsLocales: Record<string, Locale> = {
  en: enUS,
  'en-us': enUS,
  es: es,
  'es-es': es,
  el: el,
  'el-gr': el,
  'pt-br': ptBR,
  pt: ptBR,
};

export const resolveDateFnsLocale = (language: string | undefined): Locale =>
  dateFnsLocales[language?.toLowerCase() ?? ''] ?? enUS;
